/* ==========================================================================
   OTISHI 2.0 — LANDING PAGE JS

   Two jobs:
   1. Colourway picker updates the CTA link, price, and sticky bar.
   2. Sticky mobile CTA reveals ONLY after the offer section is reached,
      so it can never violate the no-CTA-above-the-offer rule.

   No dependencies. Safe to load with `defer`.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var offer = document.querySelector('[data-otishi-offer]');
    if (!offer) return;

    /* ----------------------------------------------------------------------
       1. Colourway picker
       ---------------------------------------------------------------------- */
    var radios = offer.querySelectorAll('input[name="otishi-color"]');
    var cta = offer.querySelector('[data-otishi-cta]');
    var ctaColor = offer.querySelector('[data-otishi-cta-color]');
    var ctaPrice = offer.querySelector('[data-otishi-cta-price]');
    var priceEl = offer.querySelector('[data-otishi-price]');

    var sticky = document.querySelector('[data-otishi-sticky]');
    var stickyCta = sticky && sticky.querySelector('[data-otishi-sticky-cta]');
    var stickyColor = sticky && sticky.querySelector('[data-otishi-sticky-color]');
    var stickyPrice = sticky && sticky.querySelector('[data-otishi-sticky-price]');

    function select(radio) {
      if (!radio) return;

      var url = radio.value;
      var name = radio.dataset.name || '';
      var price = radio.dataset.price || '';

      // Prefer the merchant-set display label over the raw product title.
      var labelEl = radio
        .closest('.otishi-color')
        .querySelector('.otishi-color__name');
      var label = labelEl ? labelEl.textContent.trim() : name;

      if (cta) cta.href = url;
      if (ctaColor) ctaColor.textContent = label;
      if (ctaPrice && price) ctaPrice.textContent = price;
      if (priceEl && price) priceEl.textContent = price;

      if (stickyCta) stickyCta.href = url;
      if (stickyColor) stickyColor.textContent = label;
      if (stickyPrice && price) stickyPrice.textContent = price;
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () {
        select(radio);
      });
    });

    // Sync on load in case the browser restored a selection.
    var checked = offer.querySelector('input[name="otishi-color"]:checked');
    if (checked) select(checked);

    /* ----------------------------------------------------------------------
       2. Sticky CTA reveal
       ---------------------------------------------------------------------- */
    if (!sticky) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Reveal once the top of the offer section has scrolled into view,
            // and keep it visible from that point down the page.
            var reached = entry.isIntersecting || entry.boundingClientRect.top < 0;
            sticky.classList.toggle('otishi-sticky--visible', reached);
          });
        },
        { rootMargin: '0px 0px -20% 0px', threshold: 0 }
      );

      observer.observe(offer);
    } else {
      // Fallback for old browsers: simple scroll check.
      var onScroll = function () {
        var reached = offer.getBoundingClientRect().top < window.innerHeight * 0.8;
        sticky.classList.toggle('otishi-sticky--visible', reached);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
